module.exports = __webpack_public_path__ + "img/seta-para-cima.f8ee9c5b.svg";